import { Controller } from "@hotwired/stimulus"
import { Tab } from "bootstrap"

// Keeps the active tab sticky across save-and-continue round trips and
// syncs the URL hash so the tab is bookmarkable.
export default class extends Controller {
  static targets = ["step"]
  static values = {
    initialStep: String,
    storageKey: { type: String, default: "ws-editor-tab" }
  }

  connect() {
    this.element.addEventListener("shown.bs.tab", this.onTabShown)
    this.restoreFromHashOrStorage()
    const form = this.element.querySelector("form")
    if (form) {
      form.addEventListener("submit", this.onSubmit)
      this.boundForm = form
    }
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.onTabShown)
    if (this.boundForm) {
      this.boundForm.removeEventListener("submit", this.onSubmit)
    }
  }

  restoreFromHashOrStorage = () => {
    const fromHash = window.location.hash.replace(/^#/, "")
    const fromInitialStep = this.hasInitialStepValue ? `pane-${this.initialStepValue}` : ""
    const fromStorage = sessionStorage.getItem(this.storageKeyValue)
    // The explicit server handoff must win over prior per-session history.
    // Turbo does not reliably retain fragments on form redirect responses.
    const target = fromHash || fromInitialStep || fromStorage
    if (!target) return
    const btn = this.element.querySelector(`[data-bs-target="#${CSS.escape(target)}"]`)
    if (btn) {
      Tab.getOrCreateInstance(btn).show()
      this.syncStep(target)
    }
  }

  onTabShown = (event) => {
    const id = event.target.getAttribute("data-bs-target")?.replace(/^#/, "")
    if (!id) return
    const url = new URL(window.location.href)
    url.searchParams.delete("workspace_step")
    url.hash = id
    history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`)
    this.syncStep(id)
  }

  onSubmit = () => {
    const active = this.element.querySelector(".ws-tab.active")
    const id = active?.getAttribute("data-bs-target")?.replace(/^#/, "")
    if (!id) return
    sessionStorage.setItem(this.storageKeyValue, id)
    this.syncStep(id)
  }

  syncStep(id) {
    if (this.hasStepTarget) this.stepTarget.value = id.replace(/^pane-/, "")
  }
}
